<template>
    <div class="swiper-slide p">slide</div>
</template>

<script>
export default {
    name: "design-2021-apprentice-swiper-slide-component",
    props: {
        slide: Number,
        required: true,
    }
}
</script>

<style scoped>

</style>
